import { Font } from "@react-pdf/renderer";
import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import * as serviceWorker from "./serviceWorker";
import store from "src/store";
import { load as loadCalibration } from "./store/calibration";
import { validateToken } from "./validateToken";

const DroidFont = require("./fonts/droid.ttf").default;
Font.register({ family: "Droid", src: DroidFont });
window.confirm = (params) => true; // this to disable all confirm messages in the app
if (typeof window !== "undefined") {
  //validate token before initializing react for faster loading time
  validateToken();
  store.dispatch(loadCalibration());
}
const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// serviceWorker.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// Service Worker - trigger install event
// window.addEventListener("beforeinstallprompt", (e: any) => {
//   // Prevent Chrome 67 and earlier from automatically showing the prompt
//   e.preventDefault();
//   e.prompt();
//   e.userChoice.then(() => { });
// });
reportWebVitals();
